import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalFileField from 'components/new_ui/Form/HorizontalFileField';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Managers/Profile/Actions';

export default function General({ onCloseClick }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const manager = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      manager.id,
      values,
      true,
      () => {
        setSubmitting(false);
        onCloseClick();
        actionsUsers.load(dispatchUsers);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        first_name: manager.first_name,
        last_name: manager.last_name,
        title: manager.title,
        avatar: manager.avatar_present ? manager.avatar : null,
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col lg={6}>
              <HorizontalFileField
                name="avatar"
                useCrop
              />
            </Col>

            <Col lg={6}>
              <HorizontalTextField name="first_name" label="First Name" required />

              <HorizontalTextField name="last_name" label="Last Name" required />
            </Col>
          </Row>

          <Row>
            <Col>
              <HorizontalTextField name="title" label="Position" />
            </Col>
          </Row>

          <Footer loading={isSubmitting} onCancel={() => onCloseClick()} />
        </FormikForm>
      )}
    </Formik>
  );
}

General.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};
